import { chooseContact, getInvoiceableDefaultValue, toDateString } from "helpers";
import { Job } from "./Job";
import { Times } from "./travelTimes";

export type JobVisitFormValues = {
  actionId1: string;
  actionId2?: string;
  actionId3?: string;
  customerSignatureImageData: null | string;
  customerSignerName: string;
  engineerSignatureImageData: null | string;
  serviceReportEmail: string | null;
  skipSignature: boolean;
  solutionDescription: string;
  workTimes: Times[];
  workTimesInvoiceType: string | null;
};
export type JobVisitForm = {
  values: JobVisitFormValues;
  errors: any;
};

export const initialVisitFormValues = (job: Job): JobVisitFormValues => {
  const contact = chooseContact(job.preferredContact, job.customer?.contacts);

  const action1 = job.actions?.find((x) => x?.sortId === "1");
  const action2 = job.actions?.find((x) => x?.sortId === "2");
  const action3 = job.actions?.find((x) => x?.sortId === "3");
  return {
    workTimes: job.workTimes.map((wt) => ({
      startDate: toDateString(wt.startTime)!,
      startTime: toDateString(wt.startTime)!,
      stopDate: toDateString(wt.stopTime) || undefined,
      stopTime: toDateString(wt.stopTime) || undefined,
      uploaded: true,
      pendingUpload: true,
    })),
    workTimesInvoiceType: getInvoiceableDefaultValue(job.contract?.typeObjNo),
    actionId1: action1?.id ?? "",
    actionId2: action2?.id ?? "",
    actionId3: action3?.id ?? "",
    solutionDescription: job.solutionDescription ?? "",
    customerSignerName: contact?.name ?? "",
    customerSignatureImageData: null,
    engineerSignatureImageData: null,
    skipSignature: false,
    serviceReportEmail: contact?.email ?? null,
  };
};
